import config from '../config';
import { retryFnCall } from './retryUtil';
import { trackDefaultPageView } from '../services/analyticsEvents';

/**
 * Returns params to be sent to TagCommander's virtual_page event
 * @param {string} pathname - pathname of the current route.
 * @param {Object} pathParams - route params of the current route.
 * @param {Object} [additionalParams={}] - additional params of arbitrary keys, with keys mapped to
   myaxa_param{x}_label and values mapped to myaxa_param{x}_value
 * @returns {Object}
 */

export function getVirtualPageParams(
  pathname,
  pathParams,
  additionalParams = {},
) {
  const restPaths = pathname.replace(/\/$/, '').split('/').slice(3);
  const { lang, ...restParams } = pathParams;

  const pathsReplacedWithParamName = restPaths.map((path) => {
    const matchedKey = Object.keys(restParams).find(
      (paramKey) => restParams[paramKey] === path,
    );
    if (matchedKey) return `[${matchedKey}]`;
    return path;
  });

  const virtualPageName = pathsReplacedWithParamName.join('::') || 'home';

  const optionalParams = {};

  Object.keys(restParams).forEach((key, index) => {
    optionalParams[`myaxa_param${index + 1}_label`] = key;
    optionalParams[`myaxa_param${index + 1}_value`] = restParams[key];
  });

  Object.keys(additionalParams).forEach((key) => {
    const count = Object.keys(optionalParams).length / 2;
    optionalParams[`myaxa_param${count + 1}_label`] = key;
    optionalParams[`myaxa_param${count + 1}_value`] = additionalParams[key];
  });

  return {
    myaxa_environment: config.environment,
    myaxa_pagename: virtualPageName,
    myaxa_language: lang,
    myaxa_analyticsID: '',
    myaxa_userID: config.userId || '',
    myaxa_source: config.isApp ? 'app' : 'web',
    ...optionalParams,
  };
}

export function getClientIdFromUrl() {
  const urlParams = new URLSearchParams(window.location.search);
  const clientId = urlParams.get('clientId');
  return clientId;
}

export function getGa4ClientIdFromUrl() {
  const urlParams = new URLSearchParams(window.location.search);
  const ga4ClientId = urlParams.get('ga4ClientId');
  return ga4ClientId;
}

export function getEnvFromUrl() {
  const urlParams = new URLSearchParams(window.location.search);
  const env = urlParams.get('env');
  return env;
}

export function getAxaIdFromUrl() {
  const urlParams = new URLSearchParams(window.location.search);
  const axaId = urlParams.get('axaId');
  return axaId;
}

export function trackFirstScreen(maxRetry = 5) {
  retryFnCall(
    () => {
      if (!window?.dataLayer) {
        const debugMessage = '[trackFirstScreen] window.dataLayer is not exist';
        console.debug(debugMessage);
        throw new Error(debugMessage);
      }
      trackDefaultPageView(window.location.pathname);
    },
    5,
    500,
  );
}
